import LocationCardState from './schema/LocationCardState';
import { createStore } from 'satcheljs';

const defaultLocationCardState: LocationCardState = {
    place: {
        Id: null,
        Name: null,
        Type: null,
        EmailAddress: null,
        Address: null,
        Coordinates: null,
        PhoneNumber: null,
        ResourceDetails: null,
        PlaceDetails: null,
    },
    viewState: {
        isLoading: null,
        isDataLoaded: null,
        colorScheme: null,
    },
};

export const getStore = createStore<LocationCardState>(
    'LocationCardStore',
    defaultLocationCardState
);
export default getStore;
